import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  addSubAdminUserService,
  getSubAdminStatsService,
  getSubAdminUserService,
  getSubAdminUserbyIdService,
  updateSubAdminUserService,
} from "../../../../utils/services/userManagement/subAdmin/subAdminServices";
import {
  deleteSubAdminUserService,
  activateSubAdminUserService,
  deactivateSubAdminUserService,
} from "../../../../utils/services/userManagement/subAdmin/subAdminServices";
import {
  addNewLevelService,
  getManagePermissionService,
} from "../../../../utils/services/userManagement/managePermission/managePermissionService";
import { toast } from "react-toastify";

const initialState = {
  subAdminUserLoading: true,
  subAdminUserError: "",
  subAdminUserInfo: [],
  subAdminStatInfo: [],
  permissionData: [],
  currentPage: 0,
  currentPageLimit: 10,
  searchKey: null,
};

// Get SubAdmin
export const getSubAdminUser = createAsyncThunk(
  "/subadmin/get",
  async (_, thunkAPI) => {
    const {
      currentPage,
      currentPageLimit,
      searchKey,
    } = thunkAPI.getState().subAdmin;
    console.log("Hellooo");

   

    const payload = {
      pageNo: currentPage + 1,
      pageLength: currentPageLimit,
      name: searchKey,
    };

    const response = await getSubAdminUserService(payload);
    // if (response?.error) {
    //   return thunkAPI.rejectWithValue(response?.error);
    // }
    return response;
  }
);

// Get SubAdmin
export const getSubAdminUserById = createAsyncThunk(
  "/subadmin/add",
  async (payload, thunkAPI) => {
    const response = await getSubAdminUserbyIdService();
    if (response?.error) {
      return thunkAPI.rejectWithValue(response?.error);
    }
    return response;
  }
);

// Add SubAdmin
export const addSubAdminUser = createAsyncThunk(
  "/subadmin/add",
  async (payload, thunkAPI) => {
    const { data, error } = await addSubAdminUserService(payload);
    if (error) {
      // toast.error(error?.message);
    } else {
      toast.success("Added Sub-admin successfully");
      thunkAPI.dispatch(getSubAdminUser());
    }
    return data;
  }
);

//Update Subadmin
export const updateSubAdminUser = createAsyncThunk(
  "auth/subadmin",
  async (payload, thunkAPI) => {
    console.log("PAYOAD IN ACTION", payload, " ID: ", payload.id);
    const response = await updateSubAdminUserService(payload.data, payload.id);
    if (
      response?.data?.statusCode === 200 ||
      response?.data?.statusCode === 201
    ) {
      toast.success("Updated Sub-admin successfully");
      thunkAPI.dispatch(getSubAdminUser());
    }
    return response;
  }
);
// Delete SubAdmin
export const deleteSubAdminUser = createAsyncThunk(
  "/subadmin/delete",
  async (payload, thunkAPI) => {
    const response = await deleteSubAdminUserService(payload);
    console.log(response, "heheheh");
    if (
      response?.data?.statusCode === 200 ||
      response?.data?.statusCode === 201
    ) {
      toast.success("Deleted Sub-admin successfully");
      thunkAPI.dispatch(getSubAdminUser());
    } 
    return response;
  }
);

// Activate SubAdmin
export const activateSubAdminUser = createAsyncThunk(
  "/subadmin/activate",
  async (payload, thunkAPI) => {
    const response = await activateSubAdminUserService(payload);
    if (
      response?.data?.statusCode === 200 ||
      response?.data?.statusCode === 201
    ) {
      toast.success("Activated Sub-admin successfully");
      thunkAPI.dispatch(getSubAdminUser());
    } 
    return response;
  }
);

// Deactivate SubAdmin
export const deactivateSubAdminUser = createAsyncThunk(
  "/subadmin/deactivate",
  async (payload, thunkAPI) => {
    console.log(payload, "Heyy");
    const response = await deactivateSubAdminUserService(payload);
    if (
      response?.data?.statusCode === 200 ||
      response?.data?.statusCode === 201
    ) {
      toast.success("Deactivated Sub-admin successfully");
      thunkAPI.dispatch(getSubAdminUser());
    }
    return response;
  }
);

// Get Permissiona
export const getPermission = createAsyncThunk(
  "/subadmin/permission",
  async (_, thunkAPI) => {
    const response = await getManagePermissionService();
    console.log(response);
    if (response?.error) {
      return thunkAPI.rejectWithValue(response?.error);
    }
    return response;
  }
);

//export const
const subAdminSlice = createSlice({
  name: "subAdmin",
  initialState,
  reducers: {
    resetPaginationModel(state, action) {
      state.currentPage = 0;
      state.currentPageLimit = 10;
    },
    setPaginationModel(state, action) {
      state.currentPage = action.payload.page;
      state.currentPageLimit = action.payload.pageSize;
    },
    setSearchKey(state, action) {
      state.searchKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET SubAdmin User
    builder.addCase(getSubAdminUser.pending, (state) => {
      state.subAdminUserLoading = true;
    });
    builder.addCase(getSubAdminUser.fulfilled, (state, action) => {
      state.subAdminUserLoading = false;
      state.subAdminUserInfo = action?.payload?.data?.payload;
    });
    builder.addCase(getSubAdminUser.rejected, (state, action) => {
      state.subAdminUserLoading = false;
    });

    builder.addCase(getPermission.pending, (state) => {});
    builder.addCase(getPermission.fulfilled, (state, action) => {
      state.permissionData = action?.payload?.data?.payload;
    });
    builder.addCase(getPermission.rejected, (state, action) => {});
  },
});

//Update Level
export const updateLevel = createAsyncThunk(
  "auth/subadmin",
  async (payload, thunkAPI) => {
    console.log("PAYOAD IN ACTION", payload, " ID: ", payload.id);
    const response = await updateSubAdminUserService(payload.data, payload.id);
    if (
      response?.data?.statusCode === 200 ||
      response?.data?.statusCode === 201
    ) {
      toast.success("Updated permission level successfully");
      thunkAPI.dispatch(getSubAdminUser());
    }
    return response;
  }
);

//Add Level
export const addLevel = createAsyncThunk(
  "auth/subadmin/addLevel",
  async (payload, thunkAPI) => {
    console.log("PAYOAD IN ACTION", payload);
    const response = await addNewLevelService(payload);
    if (
      response?.data?.statusCode === 200 ||
      response?.data?.statusCode === 201
    ) {
      toast.success("Added permission level successfully");
      thunkAPI.dispatch(getSubAdminUser());
    } 
    console.log("Response in Addlevel", response);
    return response;
  }
);

export const {
  resetPaginationModel,
  setPaginationModel,
  setSearchKey,
} = subAdminSlice.actions;
export default subAdminSlice.reducer;
